import { reducer as formReducer } from "redux-form";

import { API } from "@js/api";
import { savedFiltersSlice } from "@js/apps/common/components/save-filters/slice";
import { reviewsModalAutoOpenSlice } from "@js/apps/reviews/slice";

import AuthReducer from "./apps/auth/reducer";
import { bookmarksSlice } from "./apps/bookmarks/slice";
import CommonReducer from "./apps/common/reducer";
import { uploadsSlice } from "./apps/common/uploads/slice";
import { ATSJobsSlice } from "./apps/employer/components/ats-integration-modal/ats-jobs-slice";
import FreelancerReducer from "./apps/freelancer/reducer";
import InvoicesReducer from "./apps/invoices/reducer";
import BidBulkSelectionReducer from "./apps/jobs/apps/bids/components/bulk-select-actions/bid-bulk-selection-slice";
import JobsReducer from "./apps/jobs/reducer";
import NotificationsReducer from "./apps/notifications/reducer";
import OnrampReducer from "./apps/on-ramp/reducer";
import { searchEventSlice } from "./apps/tracking/search-event-slice";
import { universalSearchSlice } from "./apps/universal-search/universal-search-slice";
import WithdrawalReducer from "./apps/withdrawal/reducer";
import { modalSlice } from "./components/modal/slice";
import { requestLoaderSlice } from "./components/request-loader/slice";
import { websocketManagerSlice } from "./components/websocket/slice";

export const appReducer = {
  [API.reducerPath]: API.reducer,
  form: formReducer,
  auth: AuthReducer,
  ATSJobs: ATSJobsSlice.reducer,
  bidBulkSelection: BidBulkSelectionReducer,
  common: CommonReducer,
  freelancer: FreelancerReducer,
  invoices: InvoicesReducer,
  jobs: JobsReducer,
  modal: modalSlice.reducer,
  notifications: NotificationsReducer,
  onramp: OnrampReducer,
  requestLoader: requestLoaderSlice.reducer,
  savedFilters: savedFiltersSlice.reducer,
  uploads: uploadsSlice.reducer,
  websocketManager: websocketManagerSlice.reducer,
  withdrawal: WithdrawalReducer,
  bookmarks: bookmarksSlice.reducer,
  universalSearch: universalSearchSlice.reducer,
  searchEvent: searchEventSlice.reducer,
  reviewsModals: reviewsModalAutoOpenSlice.reducer,
};
